import React, {useState} from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";

import {t} from "../../l10n";
import ProfileLink from "../ProfileLink";
import {LocalizedLink} from "../ReactRouterDomLocalized";
import {MATERIAL_TYPE_VIDEO} from "../../constants/wallMaterials";
import {formatDate, getMaterialHash, getMSLength, isPublished} from "../../utils/wallMaterials";

import ModalConfirmPostDelete from "../modals/ModalConfirmPostDelete";

const WallMaterialListItem = ({
     wallMaterial,
     currentUser = false,
     showAuthor = false,
     showDate = true,
     showStats = true,
     onDelete = false,
     location
}) => {
    const [showModal, setShowModal] = useState(false);
    let status, play, hash, time = null;

    if (!isPublished(wallMaterial)) {
        status = <div className="status">{t('To be published')}</div>;
    } else {
        if (wallMaterial.type === MATERIAL_TYPE_VIDEO) {
            play = <div className="play"/>;
            time = <div className="time">{getMSLength(wallMaterial)}</div>;
        }

        hash = getMaterialHash(wallMaterial);
    }

    let deleteFn;
    if (onDelete && currentUser && currentUser.id === wallMaterial.user.id) {
        deleteFn = () => setShowModal(true);
    }
    
    const isMembre = currentUser && currentUser.id === wallMaterial.user.id;
    
    return (
        <div>
            <div className="wall-material-list-item">
                {deleteFn && <div className="delete" onClick={deleteFn}/>}
                <LocalizedLink to={`/le-mur/material/${wallMaterial.id + location.hash + `${location.hash ? "&" : "#"}context=${isMembre ? 'member' : 'profile'}`}`} className="thumbnail" data-type={wallMaterial.type}>
    
                    <img src={wallMaterial.thumbnail_url} alt={wallMaterial.title}/>

                    {(status || play) &&
                    <div className="overlay">
                        {status}
                        {play}
                    </div>
                    }
                    {time}
                </LocalizedLink>
                {showAuthor &&
                <div className="author-avatar">
                    <img src={wallMaterial.user.avatar_url} alt={wallMaterial.user.nick}/>
                </div>
                }
                <div className="text">
                    {showAuthor &&
                    <div className="author-block">
                        <div className="author-name">
                            <ProfileLink user={wallMaterial.user}/>
                        </div>
                    </div>
                    }
                    <p className="title" title={wallMaterial.title}>{wallMaterial.title || <span className="untitled">{t('Untitled')}</span>}</p>
                    {showDate &&
                    <p className="date">
                        {formatDate(wallMaterial)}
                    </p>
                    }
                </div>
                {showStats &&
                    <div className="stats space-between">
                        <div className="like">{wallMaterial.like_count}</div>
                        <div className="message">{wallMaterial.comment_count}</div>
                    </div>
                }
            </div>
            <ModalConfirmPostDelete show={showModal} post={wallMaterial} closeFn={() => setShowModal(false)} />
        </div>
    )
};

WallMaterialListItem.propTypes = {
    showAuthor: PropTypes.bool,
    showDate: PropTypes.bool,
    showStats: PropTypes.bool,
    openWallMaterial: PropTypes.func,
};

export default withRouter(WallMaterialListItem);



// WEBPACK FOOTER //
// ./src/components/wall/WallMaterialItem.js